import type { RouteRecordRaw } from 'vue-router';
import FdLayouts from '@/fdLayouts/index.vue';
import InvestRoute from './invest';
import NewsRoute from './news';
import BbsRoute from './bbs';
import BrandRoute from './brand';
import IndustryRoute from './industry';
import TrainingRoute from './training';
import LeagueRoute from './league';
import CompanyRoute from './company';
import CpLayouts from '@/cpLayouts/index.vue';

import FrontLogin from '@/views/frontDesk/login.vue';
import Register from '@/views/frontDesk/register.vue';
// 首页
import Index from '@/views/frontDesk/index.vue';
import About from '@/views/frontDesk/about.vue';
import Recruitment from '@/views/frontDesk/recruitment.vue';
import Member from '@/views/frontDesk/member.vue';

//
import CompanyIndex from '@/views/frontDesk/company/index.vue';
import ApplyPayment from '@/views/frontDesk/applyPayment.vue';
import ApplySuccess from '@/views/frontDesk/applySuccess.vue';

// 前台路由
export const FdRoute: Array<RouteRecordRaw> = [
  {
    path: '/frontDesk',
    name: 'FdLayouts',
    component: FdLayouts,
    children: [
      {
        path: 'index',
        name: 'Index',
        meta: {
          title: '首页',
        },
        component: Index,
      },
      {
        path: 'about',
        name: 'About',
        meta: {
          title: '关于我们 ',
        },
        component: About,
      },
      {
        path: 'recruitment',
        name: 'Recruitment',
        meta: {
          title: '人才招聘 ',
        },
        component: Recruitment,
      },
      {
        path: 'member',
        name: 'Member',
        meta: {
          title: '成为会员',
        },
        component: Member,
      },
      {
        path: 'applyPayment/:id',
        name: 'applyPayment',
        meta: {
          title: '活动报名',
        },
        component: ApplyPayment,
      },
      {
        path: 'applySuccess/:id',
        name: 'applySuccess',
        meta: {
          title: '活动报名成功',
        },
        component: ApplySuccess,
      },
      ...InvestRoute,
      ...NewsRoute,
      ...BbsRoute,
      ...BrandRoute,
      ...IndustryRoute,
      ...TrainingRoute,
      ...LeagueRoute,
    ],
  },
  {
    path: '/frontDesk/login',
    name: 'FrontLogin',
    meta: {
      title: '登录',
    },
    component: FrontLogin,
  },
  {
    path: '/frontDesk/register/:id',
    name: 'Register',
    meta: {
      title: '注册',
    },
    component: Register,
  },
  {
    path: '/company',
    name: 'CpLayouts',
    component: CpLayouts,
    children: [...CompanyRoute],
  },
  {
    path: '/company/companyIndex/:id',
    name: 'CompanyIndex',
    meta: {
      title: '会员首页',
    },
    component: CompanyIndex,
  },
];

export default FdRoute;
